import { name } from "./";

const selectCalendar = (state) => state[name].calendar;
const selectJuniorCurriculums = (state) => state[name].juniorCurriculums;
const selectSeniorCurriculums = (state) => state[name].seniorCurriculums;

export { selectJuniorCurriculums, selectSeniorCurriculums, selectCalendar };
